import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Languages = createReactComponent("Languages", ["svg", defaultAttributes, [["path", {
  d: "M5 8l6 6",
  key: "5qrnal"
}], ["path", {
  d: "M4 14l6-6 2-3",
  key: "4glnps"
}], ["path", {
  d: "M2 5h12",
  key: "16zq9b"
}], ["path", {
  d: "M7 2h1",
  key: "1lgm6t"
}], ["path", {
  d: "M22 22l-5-10-5 10",
  key: "tipqjx"
}], ["path", {
  d: "M14 18h6",
  key: "1jewtv"
}]]]);
export default Languages;